import React, { useState, useEffect } from 'react';
import SlideDown from 'react-slidedown';
import 'react-slidedown/lib/slidedown.css';
import DropDown from './DropDown';
import IconClientExit from '../../icon/IconClientExit';
import './customselect.scss';

const sliceActive = (sentance, isMobile) => {
  if (isMobile) {
    return sentance.slice(0, 12);
  } else {
    return sentance.slice(0, 20);
  }
};

const CustomSelect = ({
  label,
  id,
  name,
  placeholder,
  selectData,
  onChangeSelectData,
  selectedReason,
  setSelectedReason,
  pointerEvent,
}) => {
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const handleClick = (e) => {
    setOpen((prev) => !prev);
  };

  const handleSelect = (el, name) => {
    const newData = selectData.map((d) => {
      if (d.id === el)
        return {
          ...d,
          active: !d.active,
        };
      else return d;
    });
    setSelectedReason(newData.filter((el) => el.active));
    onChangeSelectData(newData);
    setOpen(false);
  };

  const handleUnSelect = (el, name) => {
    const newData = selectData.map((d) => {
      if (d.id === el)
        return {
          ...d,
          active: false,
        };
      else return d;
    });
    setSelectedReason(newData.filter((el) => el.active));
    onChangeSelectData(newData);
  };

  const handleUnselectAll = () => {
    const newData = selectData.map((d) => ({ ...d, active: false }));
    onChangeSelectData(newData);
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (!e.target.closest('#SelectDropdown-' + id)) {
        setOpen(false);
      }
    };

    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, [id]);

  useEffect(() => {
    const handleWindowResize = () => {
      if (window.innerWidth < 500) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return (
    <div
      className={`select_main ${pointerEvent ? 'disabled_select' : ''}`}
      id={'SelectDropdown-' + id}
      name={name}
    >
      <span className="select_text"> {label} </span>
      <div className="select_container_main" onClick={(e) => handleClick(e)}>
        <div className={`select_container ${open ? 'opened' : ''}`}>
          <div className="value">
            <span className="place">
              {' '}
              {selectData?.filter((el) => el.active).length === 0 && placeholder}
            </span>
            {selectData
              .filter((el) => el.active)
              .slice(0, isMobile ? 1 : 2)
              .map((el) => (
                <span key={el.id} className=" selected-tranch">
                  {/* {el.name.length < 20 ? el.name : el.name.slice(0, 20)} */}
                  {sliceActive(el.name, isMobile)}
                  <IconClientExit onClick={() => handleUnSelect(el.id, name)} />
                </span>
              ))}
            {!isMobile && selectData?.filter((el) => el.active).length >= 2 && (
              <div className="more-unselec-div">
                <div className="unselec-div">
                  {selectData.filter((el) => el.active)?.length} <span></span>
                </div>
                <div className="icon-select-clear" onClick={handleUnselectAll}>
                  <IconClientExit />
                </div>
              </div>
            )}
            {isMobile && selectData?.filter((el) => el.active).length >= 1 && (
              <div className="more-unselec-div">
                <div className="unselec-div">
                  {selectData.filter((el) => el.active).length} <span></span>
                </div>
                <div className="icon-select-clear" onClick={handleUnselectAll}>
                  <IconClientExit />
                </div>
              </div>
            )}
          </div>
        </div>
        <button
          className={`dropdown_button ${open ? 'opened' : ''}`}
          type="text"
        >
          <div className={`${open ? 'button_active' : ''} button_dropdown`}>
            <DropDown />
          </div>
        </button>
      </div>
      <SlideDown>
        <div
          className={
            open ? 'select_option_container ' : 'select_option_container close'
          }
        >
          {selectData.map((el, i) => (
            <div
              onClick={() => handleSelect(el.id, name)}
              className={'select_option ' + (el.active ? ' active' : '')}
              key={i}
            >
              <div className="input-checkbox-trench">
                <input
                  onChange={() => handleSelect(el.id, name)}
                  type="checkbox"
                  checked={el.active ?? false}
                  className="form-check-input radio checking checkBox"
                />
              </div>
              <div className="input-trench-text">{el.name}</div>
            </div>
          ))}
        </div>
      </SlideDown>
    </div>
  );
};

export default CustomSelect;
